import { EyeIcon } from '@heroicons/react/24/solid'
import clsx from 'clsx'
import { Button } from '@criteria-labs/react'

export type Mode = 'editor' | 'docs'

export function ModePicker({ value, onChange }: { value: Mode; onChange: (mode: Mode) => void }) {
  const pressed = value === 'docs'
  return (
    <Button
      plain
      aria-label="View Docs"
      aria-pressed={pressed}
      onClick={() => onChange(value === 'docs' ? 'editor' : 'docs')}
    >
      <EyeIcon />
      <span className={clsx(!pressed && 'text-zinc-600 dark:text-white')}>Preview Docs</span>
    </Button>
  )
}
